const loginActionStyles = {
  recoverPassword: {
    marginBottom: "1rem",
  },
  link: {
    textDecoration: "none",
    cursor: "pointer",
  },
  text: {
    textAlign: "center",
  },
  submitButton: {
    margin: "1rem 0",
  },
  termsOfServiceText: {
    fontSize: 12,
    textAlign: "center",
    marginTop: "10px",
  },
  sslLockIcon: {
    height: "12px",
  },
};
export default loginActionStyles;
